export const scrollToSection = (targetId, offset = 90) => (event) => {
    event.preventDefault();

    const targetElement = document.getElementById(targetId);
    if (targetElement) {
        window.scrollTo({
            top: targetElement.offsetTop - offset,
            behavior: 'smooth',
        });
    }
};
